class FormatDate {
    static withoutTzAndMs(iso) {
        if (!iso)
            return "";
        return iso.replace("T", " ").replace(/\..*/, "").replace(/-/g, "/");
    }
    static withoutTime(iso) {
        if (!iso)
            return "";
        const withoutTzAndMs = this.withoutTzAndMs(iso);
        return withoutTzAndMs.replace(/ .*/, "");
    }
}
export { FormatDate };
